import EditorServices from './services';
export default function(data) {
  var self = this;
  self.element = $('#tas');
  self.tas = ko.observableArray();
  self.server_errors = ko.observableArray();
  self.current_user = ko.observable();
  self.ta_rows = ko.observableArray();

  self.initUI = function() {
    EditorServices.initDropZones(self.element, self.tas);
  };

  self.bindData = function(data) {
    self.tas = ko.mapping.fromJSON(data[0]);
    self.current_user = ko.mapping.fromJSON(data[1]);
    self.ta_rows = Kadenze.UIUtil.splitRowsByCols(self.tas, 2);
  };

  self.editTA = function(item, event) {
    self.server_errors([]);
    EditorServices.showEditor($(event.target));
  };

  self.saveTA = function(item, event) {
    var index = self.tas().indexOf(item);
    var model = ko.toJS(item);
    var $target = $(event.currentTarget);
    var $editor = $target.parent().parent();

    model.social_info_attributes = model.social_info;
    delete model.social_info;

    var data = {instructor: model};
    var url = window.location.pathname + '/' + item.id();
    var method = 'PUT';

    self.client_errors = ko.validation.group(self.tas()[index], { deep: true });

    if (self.client_errors().length === 0) {
      Kadenze.UIUtil.makeRequest(url, method, data, $editor, null, function(data) {
        EditorServices.hideEditor($target);
        self.server_errors([]);
        var ta = ko.mapping.fromJS(data);
        EditorServices.updateCollection(self.tas, ta);
      }, function(data) {
        self.server_errors(data.responseJSON.instructors);
      });
    } else {
      self.client_errors.showAllMessages();
    }
  };

  self.removeTA = function(item, event)
  {
    var index = self.tas().indexOf(item);
    var model = ko.toJS(item);
    var $target = $(event.currentTarget);

    var data = { ta_id: model.id };
    var url = window.location.pathname.replace('instructors', '') + 'remove_ta';

    var method = 'POST';
    var deletePrompt = 'Are you sure you want to remove ' + item.full_name() + ' from this course?';

    Kadenze.UIUtil.confirmAction(deletePrompt, function ()
    {
      Kadenze.UIUtil.makeRequest(url, method, data, null, null, function (data)
      {
        self.tas.remove(item);
      }, function (data)
      {
        self.server_errors(data.responseJSON.errors);

        var msg = data.responseJSON.errors.join(' ');
        Kadenze.UIUtil.displayMessage('There were issues processing your request...', msg);
      });
    });
  };

  const __construct = function(that) {
    console.log('constructor called for CourseTAEditViewModel');
    that.bindData(data);
  }(this);
}
